import React from 'react';
import ResetDialog from './reset-dialog';

export default function ResetPage() {
  return <ResetDialog open />;
}
